import { styled } from "styled-components";

export const ModalTitle = styled.h2`
  font-size: 24px;
  margin-bottom: 10px;
`;
